var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},[_c('GravameEdit',{ref:"editar",on:{"close":_vm.response}}),_c('div',[_c('core-grid',{ref:"grid",attrs:{"sort-by":['estado'],"sort-desc":[false],"pageSize":-1,"onRead":_vm.onRead,"schema":_vm.schema,"addOption":false,"deleteOption":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }